import AdminPubblicita from "./AdminPubblicita";

export default AdminPubblicita;
